import {Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';

@Directive({
  selector: '[dbClickOutside]',
  standalone: true
})
export class ClickOutsideDirective implements OnInit {
  @Output()
  dbClickOutside: EventEmitter<void> = new EventEmitter();
  disabled = true;
  @Input() outsideClass: string;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: PointerEvent) {
    if (this.disabled) {
      return;
    }
    let checkOutsideElement = false
    if (this.outsideClass) {
      checkOutsideElement = document.querySelector(`.${this.outsideClass}`)?.contains(event.target as Node)
    }

    const nativeElement: any = this.elementRef.nativeElement;
    const clickedInside: boolean = nativeElement.contains(event.target) || checkOutsideElement;
    if (!clickedInside) {
      this.dbClickOutside.emit();
    }
  }

  ngOnInit() {
    setTimeout(() => {
      this.disabled = false;
    });
  }

  constructor(private elementRef: ElementRef) {
  }
}
